/* src/app/components/chat-list/chat-list.component.scss */
.conversation-group-list {
  background: #fff;
  height: 100vh;
}
.conversation-group-list .searchBox-pad {
  width: 90%;
  margin-left: 10px;
}
.conversation-group-list .input {
  height: 2rem;
}
.conversation-group-list .input-search-box {
  width: 100%;
}
.conversation-group-list .input-search-box .icon.is-left {
  height: 2rem;
}
.conversation-group-list .level-left {
  width: 100%;
}
.second-level-menu {
  max-width: 280px;
  min-width: 280px;
}
.list-wrapper ul li {
  color: var(--textsecondarycolor) !important;
}
.list-wrapper ul li .group-identify {
  top: 10px !important;
}
.list-wrapper ul li .group-identify .pi {
  font-size: 1.3rem !important;
  color: #959595 !important;
}
.list-wrapper ul li .badge-count {
  bottom: 0px !important;
}
.list-wrapper ul li.active {
  background: var(--listbackgoundhover) !important;
  color: var(--listcolor) !important;
  border-top: 1px solid #4bf768;
  border-bottom: 1px solid #4bf768;
}
.list-wrapper ul li.active .list-active,
.list-wrapper ul li.active .chat-msg-text {
  color: var(--listcolor) !important;
}
.list-wrapper ul li.active ::ng-deep .empty-img {
  background: #9affc6 !important;
}
.list-wrapper ul li:hover {
  background: var(--listbackgoundhover) !important;
}
/*# sourceMappingURL=chat-list.component.css.map */
